import React from 'react';
import { Box, Typography, Button, Card, CardContent, Avatar } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import PersonIcon from '@mui/icons-material/Person';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import { RATING_ICONS } from '../helper/ratingIcons';

// Helper: Get avatar background color based on first letter
const getAvatarColor = (name) => {
    if (!name) return '#daa520';
    return '#daa520';
};

const MyReviewCard = ({ managerData, projects, onViewFeedback, onWithdrawSubmission, withdrawingReviewId }) => {
    return (
        <Box>
            {/* Project Manager Name with Avatar */}
            <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                {/* <Avatar
                    sx={{
                        width: 25,
                        height: 25,
                        bgcolor: getAvatarColor(managerData.name),
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        p: 0.5,
                    }}
                >
                    {managerData.avatar ? (
                        <img
                            src={managerData.avatar}
                            alt={managerData.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    ) : (
                        managerData.name?.charAt(0) || <PersonIcon sx={{ fontSize: 14 }} />
                    )}
                </Avatar> */}
                <Avatar
                    sx={{
                        width: 25,
                        height: 25,
                        bgcolor: getAvatarColor(managerData.name),
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        p: managerData.avatar ? 0 : 0.5,
                    }}
                >
                    {managerData.avatar ? (
                        <img
                            src={managerData.avatar}
                            alt={managerData.name}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block',
                                borderRadius: '50%', // Ensures the image is circular
                            }}
                        />
                    ) : (
                        managerData.name?.charAt(0) || <PersonIcon sx={{ fontSize: 14 }} />
                    )}
                </Avatar>
                <Typography variant="body2" fontWeight={500} sx={{ fontSize: '14px', color: '#000' }}>
                    {managerData.name}
                </Typography>
            </Box>

            {/* Projects and Tasks Container */}
            <Box
                sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: 2,
                    maxHeight: {
                        xs: '300px',
                        sm: '350px',
                        md: '400px',
                        lg: '500px',
                        xl: '750px',
                    },
                    overflowY: 'auto',
                    p: 2,
                    '&::-webkit-scrollbar': {
                        width: '6px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#d0d0d0',
                        borderRadius: '3px',
                        '&:hover': {
                            backgroundColor: '#b0b0b0'
                        }
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '3px'
                    }
                }}
            >
                {projects && projects.map((project, projectIndex) => (
                    <Box
                        key={project.projectId}
                        mb={projectIndex < projects.length - 1 ? 2 : 0}
                        sx={{
                            border: '1px solid #e5e5e5',
                            backgroundColor: '#F6FBFF',
                            borderRadius: 2,
                            p: 2
                        }}
                    >
                        {/* Project Name with Task Count */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
                            <Typography fontSize="16px" fontWeight={600}>
                                {project.projectName}
                            </Typography>
                            {/* <Typography variant="body2" fontWeight={600} sx={{ color: '#666' }}>
                                ({project.reviews?.length || 0})
                            </Typography> */}
                        </Box>

                        {/* Tasks for this project */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            {project.reviews && project.reviews.map((review) => {
                                const isPending = review.status === 'pending';
                                const isWithdrawn = review.status === 'withdrawn';
                                const isWithdrawing = withdrawingReviewId === review.id;

                                return (
                                    <Card
                                        key={review.id}
                                        sx={{
                                            borderRadius: 2,
                                            boxShadow: 'none',
                                            border: '1px solid #E5E5E5',
                                        }}
                                    >
                                        <CardContent sx={{ p: 2.5 }}>
                                            {/* Pending review task */}
                                            {isPending && (
                                                <>
                                                    <Typography fontSize="14px" fontWeight={500} mb={0.5}>
                                                        {review.taskName}
                                                    </Typography>

                                                    <Typography fontSize="14px" color="text.primary" fontWeight={400} mb={1.5}>
                                                        {review.count}
                                                    </Typography>

                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                        display="block"
                                                        mb={2}
                                                    >
                                                        Submitted on: {review.submittedDate}
                                                    </Typography>

                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        <FiberManualRecordIcon
                                                            sx={{
                                                                fontSize: 12,
                                                                color: '#2196F3'
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: '#757575',
                                                                fontWeight: 400
                                                            }}
                                                        >
                                                            In-review
                                                        </Typography>
                                                    </Box>

                                                    <Box>
                                                        <Button
                                                            variant="outlined"
                                                            fullWidth
                                                            onClick={() => onWithdrawSubmission?.(review)}
                                                            disabled={isWithdrawing}
                                                            endIcon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                                                                    <path d="M2.38271 9.71667C2.19382 9.71667 2.0356 9.65267 1.90804 9.52467C1.78049 9.39667 1.71649 9.23844 1.71604 9.05C1.7156 8.86156 1.7796 8.70333 1.90804 8.57533C2.03649 8.44733 2.19471 8.38333 2.38271 8.38333H6.44937C7.14937 8.38333 7.75782 8.16111 8.27471 7.71667C8.7916 7.27222 9.04982 6.71667 9.04937 6.05C9.04893 5.38333 8.79071 4.82778 8.27471 4.38333C7.75871 3.93889 7.15026 3.71667 6.44937 3.71667H2.24937L3.51604 4.98333C3.63826 5.10556 3.69937 5.26111 3.69937 5.45C3.69937 5.63889 3.63826 5.79444 3.51604 5.91667C3.39382 6.03889 3.23826 6.1 3.04937 6.1C2.86049 6.1 2.70493 6.03889 2.58271 5.91667L0.182707 3.51667C0.116041 3.45 0.0687076 3.37778 0.0407076 3.3C0.0127076 3.22222 -0.000847863 3.13889 4.10259e-05 3.05C0.000929915 2.96111 0.0149297 2.87778 0.0420408 2.8C0.069152 2.72222 0.116041 2.65 0.182707 2.58333L2.58271 0.183333C2.70493 0.0611109 2.86049 0 3.04937 0C3.23826 0 3.39382 0.0611109 3.51604 0.183333C3.63826 0.305555 3.69937 0.461111 3.69937 0.65C3.69937 0.838889 3.63826 0.994444 3.51604 1.11667L2.24937 2.38333H6.44937C7.52715 2.38333 8.45226 2.73333 9.22471 3.43333C9.99715 4.13333 10.3832 5.00556 10.3827 6.05C10.3823 7.09444 9.99626 7.96667 9.22471 8.66667C8.45315 9.36667 7.52804 9.71667 6.44937 9.71667H2.38271Z" fill="#2F80ED" />
                                                                </svg>
                                                            }
                                                            sx={{
                                                                mt: 2,
                                                                borderRadius: 2,
                                                                textTransform: 'none',
                                                                color: '#2563EB',
                                                                borderColor: '#2563EB',
                                                                fontSize: '12px',
                                                                fontWeight: 500,
                                                                py: 1,
                                                                '&:hover': {
                                                                    borderColor: '#1D4ED8',
                                                                    backgroundColor: '#EFF6FF',
                                                                },
                                                                '&.Mui-disabled': {
                                                                    borderColor: '#B9D2FF',
                                                                    color: '#8FB5FF',
                                                                }
                                                            }}
                                                        >
                                                            {isWithdrawing ? 'Withdrawing...' : 'Withdraw Submission'}
                                                        </Button>
                                                    </Box>
                                                </>
                                            )}

                                            {/* Reviewed task */}
                                            {!isPending && !isWithdrawn && (
                                                <>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="flex-start"
                                                        mb={0.5}
                                                    >
                                                        <Typography variant="body1" fontWeight={600}>
                                                            {review.taskName}
                                                        </Typography>

                                                        <Box sx={{ ml: 1 }}>
                                                            {RATING_ICONS[review.rating] ?? null}
                                                        </Box>
                                                    </Box>

                                                    <Typography variant="body2" color="text.secondary" mb={1.5}>
                                                        {review.count}
                                                    </Typography>

                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                        display="block"
                                                        mb={2}
                                                    >
                                                        {/* Reviewed: {review.reviewedDate} */}
                                                        {review.autoApproved && !review.reviewedDate
                                                            ? `Auto-approved: ${review.submittedDate}`
                                                            : `Reviewed: ${review.reviewedDate}`}
                                                    </Typography>

                                                    <Button
                                                        variant="text"
                                                        onClick={() => onViewFeedback(review)}
                                                        fullWidth
                                                        startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 18 }} />}
                                                        sx={{
                                                            textTransform: 'none',
                                                            color: '#2196F3',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            padding: 0,
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            '&:hover': {
                                                                backgroundColor: 'transparent',
                                                                textDecoration: 'underline',
                                                            }
                                                        }}
                                                    >
                                                        View full feedback
                                                    </Button>
                                                </>
                                            )}

                                            {isWithdrawn && (
                                                <>
                                                    <Typography fontSize="14px" fontWeight={500} mb={0.5}>
                                                        {review.taskName}
                                                    </Typography>

                                                    <Typography variant="body2" color="text.secondary" mb={1.5}>
                                                        {review.count}
                                                    </Typography>

                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                        display="block"
                                                        mb={2}
                                                    >
                                                        Withdrawn: {review.withdrawnAt || review.submittedDate}
                                                    </Typography>

                                                    <Box display="flex" alignItems="center" gap={1} mb={2}>
                                                        <FiberManualRecordIcon
                                                            sx={{
                                                                fontSize: 12,
                                                                color: '#C67C00'
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: '#8A5A00',
                                                                fontWeight: 400
                                                            }}
                                                        >
                                                            Withdrawn before review
                                                        </Typography>
                                                    </Box>

                                                    <Button
                                                        variant="text"
                                                        onClick={() => onViewFeedback(review)}
                                                        fullWidth
                                                        startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 18 }} />}
                                                        sx={{
                                                            textTransform: 'none',
                                                            color: '#2196F3',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            padding: 0,
                                                            fontSize: '12px',
                                                            fontWeight: 500,
                                                            '&:hover': {
                                                                backgroundColor: 'transparent',
                                                                textDecoration: 'underline',
                                                            }
                                                        }}
                                                    >
                                                        View submission details
                                                    </Button>
                                                </>
                                            )}
                                        </CardContent>
                                    </Card>
                                );
                            })}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box >
    );
};

export default MyReviewCard;
